import React, {ReactNode} from 'react'
import BreadCrumb from 'src/_metronic/layout/components/breadcrumb'

interface FinanceLayoutProps {
  currentPage?: string
  title?: string
  description?: string
  actions?: ReactNode
  children: ReactNode
  onBack?: () => void
}

export default function FinanceLayout({
  currentPage,
  title,
  description,
  actions,
  children,
  onBack,
}: FinanceLayoutProps) {
  return (
    <>
      {title && description && (
        <div>
          <h3 className='text-dark fw-bolder mt-10 mb-2'>{title}</h3>
          <p className='fs-6 mb-0'>{description}</p>
        </div>
      )}
      {children}
    </>
  )
}
